import locales from '@spa/shared/constants/locales';

const localeRegex = RegExp('^/[a-zA-Z]{2}($|/)');

export const getLanguageFromPath = path => (localeRegex.test(path) ? path.slice(1, 3) : '');

export const getLocaleFromPath = path => {
  const language = getLanguageFromPath(path).toUpperCase();

  return locales[language];
};

export const languageToLocale = (language = 'en') => locales[language.toUpperCase()];

export const localeToLanguage = (locale = locales.EN) => {
  const language = Object.keys(locales).find(key => locales[key] === locale) || 'en';

  return language.toLowerCase();
};

export const localeToHyphenFormat = (locale = locales.EN) => locale.replace('_', '-');
